
export default {
  props: {
    articles: {
      type: Array,
      default: () => [],
    },
    content: {
      type: Array,
      default: () => [],
    },
    episodes: {
      type: Array,
      default: () => [],
    },
    podcastFeed: {
      type: Array,
      default: () => [],
    },
    extraContent: {
      type: Array,
      default: () => [],
    },
    hasMore: {
      type: Boolean,
      default: null,
    },
    genreName: {
      type: String,
      default: null,
    },
    id: {
      type: String,
      default: null,
    },
    intro: {
      type: String,
      default: null,
    },
    logo: {
      type: String,
      default: null,
    },
    modelName: {
      type: String,
      default: null,
    },
    platforms: {
      type: Array,
      default: () => [],
    },
    presenters: {
      type: Array,
      default: () => [],
    },
    slug: {
      type: String,
      default: null,
    },
    title: {
      type: String,
      default: null,
    },
    topic: {
      type: Object,
      default: () => {},
    },
    type: {
      type: String,
      default: null,
    },
  },
  asyncData ({ store, route, params: { slug } }) {
    // Set breadcrumbs for the page
    store.dispatch('breadcrumbs/mirror', {
      path: route.path,
      mirror: `/programmas/${slug}`,
    })
  },
  data () {
    return {
      amountEpisodesVisible: 6,
      amountArticlesVisible: 6,
      articlesLimit: 6,
      articlesOffset: 0,
      articlesList: [],
    }
  },
  computed: {
    visibleEpisodes () {
      // return this.episodes?.slice(0, this.amountVisible)
      return this.episodes?.slice(0, this.amountEpisodesVisible)
    },
    hasMoreEpisodes () {
      return !(this.amountVisible >= this.episodes?.length)
    },
    hasMoreArticles () {
      return !(this.amountVisible >= this.articlesList?.length)
    },
  },
  created () {
    this.articlesList = this.articles
    this.articlesOffset = this.articlesList?.length
  },
  activated () {
    this.articlesList = this.articles
    this.articlesOffset = this.articlesList?.length
  },
  methods: {
    /**
     * Show more episodes on the page
     */
    showMoreEpisodes () {
      if (this.hasMoreEpisodes) {
        this.amountVisible = this.amountVisible + 6
      } else {
        this.amountVisible = this.episodes.length
      }
    },
    /**
     * Get more articles from the podcast
     */
    async fetchMoreArticles () {
      const {
        data: {
          items: articles = [],
        } = {},
      } = await this.$api.articles.getAll({
        offset: this.articlesList.length,
        limit: 6,
        podcast: this.id,
      })

      this.articlesList.push(...articles)
    },
  },
}
